import React from "react"
import PropTypes from "prop-types"
import {observer} from "mobx-react"
import DemandeStore from "./DemandeStore"
import { MemoryRouter as Router, Route, Link } from "react-router-dom";
import {Redirect } from "react-router-dom";
import 'moment/locale/fr';
import User from "./User/User"
import Bien from "./Bien/Bien"
import Rdv from "./Rdv/Rdv"
@observer
class Routeur extends React.Component {
  constructor(props) {
    super(props);
    let redirect = ""
    this.state= {
      redirect: redirect
    }

  }

  render () {
      return (
        <React.Fragment>
         <Router>
          <div>
          <div className="container">
            <ul className="stepper">
              <li className="step active">
                <span className="upper-text"></span>
                <span className="dot"></span>
                <Link to="/">
                <span className="lower-text">
                   Infos propriétaire
                </span>
                </Link>
              </li>
              <li className={"step "+(DemandeStore.user.email =="" ? "" : "active")}>
                <span className="upper-text"></span>
                <span className="dot"></span>
                <Link  to="/bien">
                <span className="lower-text">
                  Infos Bien
                </span>
                </Link>
              </li>
              <li className={"step "+(DemandeStore.bien == "" ? "" : "active")}>
                <span className="upper-text"></span>
                <span className="dot"></span>
                <Link to="/rdv">
                  <span className="lower-text">
                    Infos rendez-vous
                  </span>
                </Link>
              </li>
            </ul>
          </div>
            <Route path="/" exact component={User} />
            <Route path="/bien" exact component={Bien} />
            <Route path="/rdv" exact component={Rdv} />
          </div>
        </Router>
        </React.Fragment>
      );
  }
}

export default Routeur
